import { workspaceApi } from "@/api/workspace-api";
import { useWorkspaceStore } from "@/store/workspace-store";
import { IWorkspace } from "@/types/data-models";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";

export function useWorkspaceSettings() {
  const { activeWorkspaceId } = useWorkspaceStore();
  const queryClient = useQueryClient();

  const { data: workspace, isLoading } = useQuery({
    queryKey: ["workspace", activeWorkspaceId],
    queryFn: () => workspaceApi.getWorkspace(activeWorkspaceId || ""),
    enabled: !!activeWorkspaceId,
  });

  const updateWorkspaceMutation = useMutation({
    mutationFn: (data: Partial<IWorkspace>) =>
      workspaceApi.updateWorkspace(activeWorkspaceId || "", data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["workspace", activeWorkspaceId],
      });
      toast.success("Settings updated successfully");
    },
    onError: () => {
      toast.error("Failed to update settings");
    },
  });

  return {
    workspace: workspace?.result,
    isLoading,
    activeWorkspaceId,
    updateWorkspaceMutation,
    invalidateWorkspace: () =>
      queryClient.invalidateQueries({
        queryKey: ["workspace", activeWorkspaceId],
      }),
  };
}
